import React, { useEffect, useState } from 'react';
import Alert from '../../../layouts/Alert';
import _ from 'underscore';

import BuildingListItem from './BuildingListItem';
import Search from '../../../layouts/Search';
import SortIcon from '../../../layouts/SortIcon';
import BuildingFilter from './BuildingFilter';
import Pagination from '../../../layouts/Pagination';

const BuildingsList = ({ buildingsList, buildingListLoading }) => {
  const [listSearch, setListSearch] = useState(buildingsList);
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(1);

  const [icons, setIcons] = useState({
    name: 0,
  });

  const { name } = icons;

  useEffect(() => {
    if (!buildingListLoading) {
      setListSearch(buildingsList);
    }
  }, [buildingListLoading, setListSearch, buildingsList]);

  // const setFilter = (data) => {
  //   setListSearch(
  //     buildingsList.filter((item) =>

  //     ),
  //   );
  // };

  return (
    <div className='card w-100 p-2 p-sm-3 p-lg-5 shadow-lg border-0 admin-list h-100'>
      <Alert />
      <div className='d-flex w-100 align-items-center justify-content-between mb-3'>
        <div className=''>
          {!buildingListLoading && listSearch.length / 7 > 1 && (
            <Pagination
              listSearch={listSearch}
              setPage={setPage}
              size={7}
              page={page}
            />
          )}
        </div>
        <div className='d-flex'>
          <Search
            setListSearch={setListSearch}
            filter={(e) => {
              const list = buildingsList.filter(
                (item) =>
                  item.name
                    .toUpperCase()
                    .includes(e.target.value.toUpperCase()) ||
                  item.client.title
                    .toUpperCase()
                    .includes(e.target.value.toUpperCase()),
              );
              return list;
            }}
            setSearch={setSearch}
          />
          {/* <BuildingFilter
            buildingsList={buildingsList}
            setFilter={setFilter}
            setListSearch={setListSearch}
          /> */}
        </div>
      </div>
      <div className='row m-0 rounded admin-list-header txt-primary p-2 w-100'>
        <div
          className='admin-list-fields col p-0 text-truncate '
          onClick={() => {
            if (name === 0) {
              setListSearch(_.sortBy(listSearch, 'name'));
              setIcons({
                name: 1,
              });
            } else if (name === 1) {
              let l = _.sortBy(listSearch, 'name');
              setListSearch(l.reverse());
              setIcons({
                name: -1,
              });
            } else {
              setListSearch(buildingsList);
              setIcons({
                name: 0,
              });
            }
          }}
        >
          Name
          <SortIcon icon={name} />
        </div>
        <div
          className='admin-list-fields col p-0 text-truncate '
          // onClick={() => {
          //   if (name === 0) {
          //     setListSearch(_.sortBy(listSearch, 'name'));
          //     setIcons({
          //       name: 1,
          //     });
          //   } else if (name === 1) {
          //     let l = _.sortBy(listSearch, 'name');
          //     setListSearch(l.reverse());
          //     setIcons({
          //       name: -1,
          //     });
          //   } else {
          //     setListSearch(buildingsList);
          //     setIcons({
          //       name: 0,
          //     });
          //   }
          // }}
        >
          Client
          {/* <SortIcon icon={name} /> */}
        </div>

        <div className='admin-list-fields col p-0 text-truncate text-center'>
          Actions
        </div>
      </div>
      <div className='admin-list-body'>
        {buildingListLoading ? (
          <div className='d-flex justify-content-center align-items-center h-100'>
            <div class='spinner-border txt-primary' role='status'>
              <span class='visually-hidden'>Loading...</span>
            </div>
          </div>
        ) : (
          listSearch
            .slice(7 * (page - 1), 7 * page)
            .map((building, id) => (
              <BuildingListItem building={building} key={id} />
            ))
        )}
      </div>
    </div>
  );
};

export default BuildingsList;
